// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Unified Action Panel Styles
 * Consistent action panel for all management pages
 */

/* Unified Action Panel */
.unified-action-panel {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    margin: 0 25px 30px 25px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.unified-action-panel-content {
    padding: 24px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.02) 0%, rgba(118, 75, 162, 0.02) 100%);
    border-radius: 16px;
    position: relative;
    overflow: hidden;
}

.unified-action-section {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 12px;
    padding: 24px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(102, 126, 234, 0.1);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

.unified-action-section-title {
    color: #2d3748;
    font-size: 1.125rem;
    font-weight: 700;
    margin: 0 0 20px 0;
    line-height: 1.3;
    display: flex;
    align-items: center;
    gap: 8px;
}

.unified-action-controls-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    align-items: start;
}

.unified-selection-controls-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.unified-action-controls-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.unified-select-all-container {
    display: flex;
    align-items: center;
}

.unified-checkbox-label {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    padding: 12px 20px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
    color: #2d3748;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.unified-checkbox-label:hover {
    background: rgba(255, 255, 255, 1);
    border-color: rgba(102, 126, 234, 0.5);
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.unified-checkbox {
    width: 20px;
    height: 20px;
    accent-color: #0D3B66;
    border-radius: 4px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
}

.unified-checkbox:hover {
    border-color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.15);
}

.unified-checkbox:checked {
    background: #EA580C;
    border-color: #EA580C;
}

.unified-checkbox-custom {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.1);
    position: relative;
    transition: all 0.3s ease;
}

.unified-checkbox-text {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #2d3748;
    font-weight: 600;
    font-size: 14px;
}

.unified-checkbox-icon {
    font-size: 16px;
}

.unified-clear-selection-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: linear-gradient(135deg, #f56565, #e53e3e);
    border: 2px solid #e53e3e;
    border-radius: 10px;
    color: white;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3);
}

.unified-clear-selection-btn:hover {
    background: linear-gradient(135deg, #e53e3e, #c53030);
    border-color: #c53030;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(229, 62, 62, 0.4);
}

.unified-btn-icon {
    font-size: 1rem;
}

.unified-btn-text {
    font-weight: 500;
}

.unified-action-selector {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.unified-action-select-wrapper {
    position: relative;
}

.unified-action-select {
    width: 100%;
    padding: 12px 20px;
    border: 2px solid rgba(102, 126, 234, 0.3);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    font-size: 14px;
    font-weight: 500;
    color: #2d3748;
    cursor: pointer;
    transition: all 0.3s ease;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding-right: 40px;
}

.unified-action-select:focus {
    outline: none;
    border-color: rgba(102, 126, 234, 0.5);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.unified-action-select:disabled {
    background: rgba(255, 255, 255, 0.5);
    color: #9ca3af;
    cursor: not-allowed;
    border-color: rgba(102, 126, 234, 0.2);
}

.unified-action-select option {
    padding: 8px;
    background: white;
    color: #2d3748;
    font-weight: 500;
}

.unified-select-arrow {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #0D3B66;
    font-size: 12px;
    font-weight: bold;
}

.unified-execute-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 24px;
    background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
    border: 2px solid #EA580C;
    border-radius: 12px;
    color: white;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    position: relative;
    overflow: hidden;
}

.unified-execute-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
}

.unified-execute-btn:hover::before {
    left: 100%;
}

.unified-execute-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, #C2410C 0%, #FB923C 100%);
    border-color: #C2410C;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(234, 88, 12, 0.4);
}

.unified-execute-btn:active:not(:disabled) {
    transform: translateY(0);
}

.unified-execute-btn:disabled {
    background: #9ca3af;
    border-color: #9ca3af;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.unified-btn-badge {
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Additional Actions */
.unified-additional-actions {
    margin-top: 20px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 25px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
}

/* Responsive Design */
@media (max-width: 1024px) {
    .unified-action-panel-content {
        padding: 20px;
    }

    .unified-action-controls-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }
}

@media (max-width: 768px) {
    .unified-action-panel {
        margin: 0 20px 20px 20px;
    }

    .unified-action-panel-content {
        padding: 20px;
    }

    .unified-action-controls-grid {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .unified-checkbox-label {
        padding: 10px 16px;
        font-size: 13px;
    }

    .unified-action-select {
        padding: 10px 16px;
        font-size: 13px;
    }

    .unified-execute-btn {
        padding: 10px 20px;
        font-size: 13px;
    }
}

@media (max-width: 480px) {
    .unified-action-panel {
        margin: 0 15px 15px 15px;
    }

    .unified-action-panel-content {
        padding: 16px;
    }

    .unified-action-section {
        padding: 16px;
    }

    .unified-checkbox-label {
        padding: 8px 12px;
        font-size: 12px;
    }

    .unified-action-select {
        padding: 8px 12px;
        font-size: 12px;
    }

    .unified-execute-btn {
        padding: 8px 16px;
        font-size: 12px;
    }

    .unified-action-controls-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/UnifiedActionPanel.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,yBAAyB;AACzB;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,wBAAwB;IACxB,yCAAyC;IACzC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gGAAgG;IAChG,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,2BAA2B;IAC3B,0CAA0C;IAC1C,yBAAyB;IACzB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,sCAAsC;IACtC,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,oCAAoC;IACpC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qDAAqD;IACrD,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,qDAAqD;IACrD,qBAAqB;IACrB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;IACrB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;AACJ","sourcesContent":["/**\n * Unified Action Panel Styles\n * Consistent action panel for all management pages\n */\n\n/* Unified Action Panel */\n.unified-action-panel {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-radius: 16px;\n    margin: 0 25px 30px 25px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n}\n\n.unified-action-panel-content {\n    padding: 24px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.02) 0%, rgba(118, 75, 162, 0.02) 100%);\n    border-radius: 16px;\n    position: relative;\n    overflow: hidden;\n}\n\n.unified-action-section {\n    background: rgba(255, 255, 255, 0.8);\n    border-radius: 12px;\n    padding: 24px;\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(102, 126, 234, 0.1);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);\n}\n\n.unified-action-section-title {\n    color: #2d3748;\n    font-size: 1.125rem;\n    font-weight: 700;\n    margin: 0 0 20px 0;\n    line-height: 1.3;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.unified-action-controls-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    align-items: start;\n}\n\n.unified-selection-controls-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.unified-action-controls-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.unified-select-all-container {\n    display: flex;\n    align-items: center;\n}\n\n.unified-checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    cursor: pointer;\n    padding: 12px 20px;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 12px;\n    backdrop-filter: blur(10px);\n    border: 2px solid rgba(102, 126, 234, 0.3);\n    transition: all 0.3s ease;\n    color: #2d3748;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.unified-checkbox-label:hover {\n    background: rgba(255, 255, 255, 1);\n    border-color: rgba(102, 126, 234, 0.5);\n    transform: translateY(-1px);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.unified-checkbox {\n    width: 20px;\n    height: 20px;\n    accent-color: #0D3B66;\n    border-radius: 4px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    background: rgba(255, 255, 255, 0.1);\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.unified-checkbox:hover {\n    border-color: rgba(255, 255, 255, 0.5);\n    background: rgba(255, 255, 255, 0.15);\n}\n\n.unified-checkbox:checked {\n    background: #EA580C;\n    border-color: #EA580C;\n}\n\n.unified-checkbox-custom {\n    width: 20px;\n    height: 20px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-radius: 4px;\n    background: rgba(255, 255, 255, 0.1);\n    position: relative;\n    transition: all 0.3s ease;\n}\n\n.unified-checkbox-text {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #2d3748;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.unified-checkbox-icon {\n    font-size: 16px;\n}\n\n.unified-clear-selection-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    background: linear-gradient(135deg, #f56565, #e53e3e);\n    border: 2px solid #e53e3e;\n    border-radius: 10px;\n    color: white;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3);\n}\n\n.unified-clear-selection-btn:hover {\n    background: linear-gradient(135deg, #e53e3e, #c53030);\n    border-color: #c53030;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(229, 62, 62, 0.4);\n}\n\n.unified-btn-icon {\n    font-size: 1rem;\n}\n\n.unified-btn-text {\n    font-weight: 500;\n}\n\n.unified-action-selector {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.unified-action-select-wrapper {\n    position: relative;\n}\n\n.unified-action-select {\n    width: 100%;\n    padding: 12px 20px;\n    border: 2px solid rgba(102, 126, 234, 0.3);\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.9);\n    backdrop-filter: blur(10px);\n    font-size: 14px;\n    font-weight: 500;\n    color: #2d3748;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    padding-right: 40px;\n}\n\n.unified-action-select:focus {\n    outline: none;\n    border-color: rgba(102, 126, 234, 0.5);\n    background: rgba(255, 255, 255, 1);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.unified-action-select:disabled {\n    background: rgba(255, 255, 255, 0.5);\n    color: #9ca3af;\n    cursor: not-allowed;\n    border-color: rgba(102, 126, 234, 0.2);\n}\n\n.unified-action-select option {\n    padding: 8px;\n    background: white;\n    color: #2d3748;\n    font-weight: 500;\n}\n\n.unified-select-arrow {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none;\n    color: #0D3B66;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.unified-execute-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 12px 24px;\n    background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n    border: 2px solid #EA580C;\n    border-radius: 12px;\n    color: white;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n    position: relative;\n    overflow: hidden;\n}\n\n.unified-execute-btn::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n    transition: left 0.5s ease;\n}\n\n.unified-execute-btn:hover::before {\n    left: 100%;\n}\n\n.unified-execute-btn:hover:not(:disabled) {\n    background: linear-gradient(135deg, #C2410C 0%, #FB923C 100%);\n    border-color: #C2410C;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(234, 88, 12, 0.4);\n}\n\n.unified-execute-btn:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.unified-execute-btn:disabled {\n    background: #9ca3af;\n    border-color: #9ca3af;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.unified-btn-badge {\n    background: rgba(255, 255, 255, 0.2);\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n/* Additional Actions */\n.unified-additional-actions {\n    margin-top: 20px;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-radius: 20px;\n    padding: 25px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n    .unified-action-panel-content {\n        padding: 20px;\n    }\n\n    .unified-action-controls-grid {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n}\n\n@media (max-width: 768px) {\n    .unified-action-panel {\n        margin: 0 20px 20px 20px;\n    }\n\n    .unified-action-panel-content {\n        padding: 20px;\n    }\n\n    .unified-action-controls-grid {\n        grid-template-columns: 1fr;\n        gap: 16px;\n    }\n\n    .unified-checkbox-label {\n        padding: 10px 16px;\n        font-size: 13px;\n    }\n\n    .unified-action-select {\n        padding: 10px 16px;\n        font-size: 13px;\n    }\n\n    .unified-execute-btn {\n        padding: 10px 20px;\n        font-size: 13px;\n    }\n}\n\n@media (max-width: 480px) {\n    .unified-action-panel {\n        margin: 0 15px 15px 15px;\n    }\n\n    .unified-action-panel-content {\n        padding: 16px;\n    }\n\n    .unified-action-section {\n        padding: 16px;\n    }\n\n    .unified-checkbox-label {\n        padding: 8px 12px;\n        font-size: 12px;\n    }\n\n    .unified-action-select {\n        padding: 8px 12px;\n        font-size: 12px;\n    }\n\n    .unified-execute-btn {\n        padding: 8px 16px;\n        font-size: 12px;\n    }\n\n    .unified-action-controls-grid {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
